import React, { useEffect, useState } from "react"
import { Button, Dropdown } from "react-bootstrap"
import { defineMessages, injectIntl } from "react-intl"
import { Intl } from "../../../state/helpers/IntlProps"
import RowCustomStatus from "../../../state/pricing/rowcustomstatus/RowCustomStatus"

const messages = defineMessages({
    "noneRowCustomStatusName": {
        id: "pricing.row_custom_status.component.row_custom_status_dropdown_component.none_name",
        defaultMessage: "None"
    }
})

type Props = {
    intl: Intl
    className: string
    selectedRowCustomStatusID: string
    buttonStyle: object
    rowCustomStatuses: RowCustomStatus[]
    onSelectCallback: (id: string) => object
}

const RowCustomStatusDropdownComponent = (props: Props) => {
    if (props.rowCustomStatuses.length == 0) return <></>
    const rowCustomStatus = props.rowCustomStatuses.find(s => s.getId() == props.selectedRowCustomStatusID) ||
        new RowCustomStatus({
            id: "",
            type: "row-custom-status",
            attributes: {
                name: props.intl.formatMessage(messages["noneRowCustomStatusName"]),
                rank: -1,
                color: "secondary",
            }
        })

    const [selectedRowCustomStatus, setSelectedRowCustomStatus] = useState(rowCustomStatus)

    useEffect(() => {
        setSelectedRowCustomStatus(rowCustomStatus)
    }, [rowCustomStatus.getId()])

    const onRowCustomStatusUpdated = (s: RowCustomStatus) => {
        setSelectedRowCustomStatus(s)
        props.onSelectCallback(s.getId())
    }

    if (!selectedRowCustomStatus) return <></>
    return (
        <>
            <Dropdown className={props.className}>
                <Dropdown.Toggle className={"btn-sm btn-block"} style={props.buttonStyle ?? {}}
                    variant={selectedRowCustomStatus.getColor()} id="dropdown-basic">
                    {selectedRowCustomStatus.getName()}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {props.rowCustomStatuses.map((s, i) => {
                        return <Dropdown.Item key={i} onClick={() => onRowCustomStatusUpdated(s)}>
                            <Button
                                size={"sm"}
                                variant={s.getColor()}>
                                {s.getName()}
                            </Button>
                        </Dropdown.Item>
                    })}
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
}

export default injectIntl(RowCustomStatusDropdownComponent)


// WEBPACK FOOTER //
// ./src/pricing/rowcustomstatus/component/RowCustomStatusDropdownComponent.tsx